import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRequirementsVersionsMutationVariables = Types.Exact<{
  input: Types.UpdateRequirementsVersionsInput;
}>;


export type UpdateRequirementsVersionsMutation = { __typename?: 'Mutation', updateRequirementsVersions: { __typename?: 'UpdateRequirementsVersionsPayload', int?: number | null } };


export const UpdateRequirementsVersionsDocument = gql`
    mutation UpdateRequirementsVersions($input: UpdateRequirementsVersionsInput!) {
  updateRequirementsVersions(input: $input) {
    int
  }
}
    `;
export type UpdateRequirementsVersionsMutationFn = Apollo.MutationFunction<UpdateRequirementsVersionsMutation, UpdateRequirementsVersionsMutationVariables>;

/**
 * __useUpdateRequirementsVersionsMutation__
 *
 * To run a mutation, you first call `useUpdateRequirementsVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequirementsVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequirementsVersionsMutation, { data, loading, error }] = useUpdateRequirementsVersionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRequirementsVersionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequirementsVersionsMutation, UpdateRequirementsVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequirementsVersionsMutation, UpdateRequirementsVersionsMutationVariables>(UpdateRequirementsVersionsDocument, options);
      }
export type UpdateRequirementsVersionsMutationHookResult = ReturnType<typeof useUpdateRequirementsVersionsMutation>;
export type UpdateRequirementsVersionsMutationResult = Apollo.MutationResult<UpdateRequirementsVersionsMutation>;
export type UpdateRequirementsVersionsMutationOptions = Apollo.BaseMutationOptions<UpdateRequirementsVersionsMutation, UpdateRequirementsVersionsMutationVariables>;